import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Keep search bar text synchronized with the active URL search parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const q = params.get('q');
    if (q) {
      setQuery(q); // URLSearchParams decodes it automatically
    } else {
      setQuery('');
    }
  }, [location.search]);

  const performSearch = () => {
    const trimmedQuery = query.trim();
    const params = new URLSearchParams(location.search);
    
    if (trimmedQuery) {
      // Set 'q' to replace previous search term
      params.set('q', trimmedQuery);
    } else {
      params.delete('q');
    }
    
    navigate(`/browse?${params.toString()}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      performSearch();
    }
  };

  return (
    <div className="flex justify-center my-6 w-full px-4">
      <div className="flex w-full max-w-2xl">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-grow p-2 border border-gray-300 rounded-l-md text-black focus:outline-none focus:ring-2 focus:ring-cyan-500"
          placeholder="Search for cars (e.g., Toyota Corolla 2022)..."
        />
        <button
          type="button"
          onClick={performSearch}
          className="bg-white text-black p-2 border rounded-r-md border-red-500 hover:border-magenta hover:scale-105 transition-all shadow-sm font-fairplay px-6"
          disabled={!query.trim()}
        >
          Search
        </button>
      </div>
    </div>
  );
}
